/**
 * @generated SignedSource<<15470b914ba857e16f242f04a01fcda4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStyleContentQuery$data = {
  readonly section: {
    readonly fullSectionPath: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleMainQuery" | "sectionStyleSubArticleListQuery" | "sectionStyleSubHeadQuery">;
  readonly " $fragmentType": "sectionStyleContentQuery";
};
export type sectionStyleContentQuery$key = {
  readonly " $data"?: sectionStyleContentQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleContentQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "articlesQueueName",
  "variableName": "articlesQueueName"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "articlesQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityId"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isSectionStyleMain"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "relatedSectionsQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionStyleContentQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityId",
              "variableName": "entityId"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "fullSectionPath",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isSectionStyleMain",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v0/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "sectionStyleMainQuery"
        }
      ]
    },
    {
      "condition": "isSectionStyleMain",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "relatedSectionsQueueName",
              "variableName": "relatedSectionsQueueName"
            }
          ],
          "kind": "FragmentSpread",
          "name": "sectionStyleSubHeadQuery"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "after",
              "variableName": "after"
            },
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "kind": "FragmentSpread",
          "name": "sectionStyleSubArticleListQuery"
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "57600c2b0aed2cf287222d580d4eaad8";

export default node;
